import apiClient from './api.service';

export interface QualityPlanItem {
  id: string;
  company_id: string;
  quality_plan_id: string;
  inspection_point_id?: string;
  item_id?: string;
  sequence_number: number;
  display_order?: number;
  parent_item_id?: string;
  level: number;
  inspection_type: 'Hold Point' | 'Witness Point' | 'Review Point' | 'Standard';
  description: string;
  acceptance_criteria?: string;
  measurement_parameters?: any;
  required_personnel_qualification?: string;
  assigned_inspector_id?: string;
  witness_required: boolean;
  witness_party?: string;
  mandatory: boolean;
  can_skip: boolean;
  status: 'Pending' | 'Scheduled' | 'In Progress' | 'Completed' | 'Skipped' | 'On Hold';
  scheduled_date?: string;
  completed_date?: string;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
}

class QualityPlanItemService {
  async getAll(planId: string): Promise<QualityPlanItem[]> {
    const response = await apiClient.get(`/quality/quality-plans/${planId}/items`);
    return response.data || [];
  }

  async getById(planId: string, itemId: string): Promise<QualityPlanItem> {
    const response = await apiClient.get(`/quality/quality-plans/${planId}/items/${itemId}`);
    return response.data;
  }

  async create(planId: string, data: Partial<QualityPlanItem>): Promise<QualityPlanItem> {
    const response = await apiClient.post(`/quality/quality-plans/${planId}/items`, data);
    return response.data;
  }

  async update(planId: string, itemId: string, data: Partial<QualityPlanItem>): Promise<QualityPlanItem> {
    const response = await apiClient.put(`/quality/quality-plans/${planId}/items/${itemId}`, data);
    return response.data;
  }

  async delete(planId: string, itemId: string): Promise<void> {
    await apiClient.delete(`/quality/quality-plans/${planId}/items/${itemId}`);
  }

  async reorder(planId: string, itemIds: string[]): Promise<QualityPlanItem[]> {
    const response = await apiClient.post(`/quality/quality-plans/${planId}/items/reorder`, { itemIds });
    return response.data || [];
  }

  async bulkCreate(planId: string, items: Partial<QualityPlanItem>[]): Promise<QualityPlanItem[]> {
    const response = await apiClient.post(`/quality/quality-plans/${planId}/items/bulk`, { items });
    return response.data || [];
  }
}

const qualityPlanItemService = new QualityPlanItemService();
export default qualityPlanItemService;
export { qualityPlanItemService };
